// Defensive formatting/number helpers shared by the GPS "Formulaires" components.
// Every helper treats null / undefined / NaN / wrong-type as a safe value, never throws.

// Greyed label shown when a form template has no name (explorer + detail table).
export const TEMPLATE_FALLBACK_LABEL = 'Formulaire sans nom';

// Coerce to a finite number, falling back to `fallback` (default 0).
export const safeNum = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

// Always return an array (empty for anything that is not an array).
export const safeArray = (v) => (Array.isArray(v) ? v : []);

// French integer formatting (thousands grouped); "—" for non-finite.
export const formatInt = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return Math.round(n).toLocaleString('fr-FR');
};

// Format a 0–1 rate as a French percentage string ("61 %"); "—" when invalid.
export const formatRate = (rate, digits = 0) => {
  const n = Number(rate);
  if (!Number.isFinite(n)) return '—';
  const clamped = Math.max(0, n);
  return `${(clamped * 100).toLocaleString('fr-FR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })} %`;
};

// Format a fraction (0–1) as a percent number for charts (no unit); 0 when invalid.
export const ratioToPct = (rate, digits = 0) => {
  const n = Number(rate);
  if (!Number.isFinite(n)) return 0;
  return Number((Math.max(0, n) * 100).toFixed(digits));
};

// Delta direction between current/previous: 'up' | 'down' | 'flat'.
export const deltaDirection = (current, previous) => {
  const c = Number(current);
  const p = Number(previous);
  if (!Number.isFinite(c) || !Number.isFinite(p)) return 'flat';
  if (c > p) return 'up';
  if (c < p) return 'down';
  return 'flat';
};

// Arrow glyph + tailwind color class for a delta direction.
export const deltaArrow = (direction) => {
  switch (direction) {
    case 'up':
      return { glyph: '▲', className: 'text-emerald-600 dark:text-emerald-400' };
    case 'down':
      return { glyph: '▼', className: 'text-red-600 dark:text-red-400' };
    default:
      return { glyph: '▬', className: 'text-gray-500 dark:text-gray-400' };
  }
};

// Signed integer string ("+3" / "-2" / "0").
export const signedInt = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '0';
  const rounded = Math.round(n);
  return `${rounded > 0 ? '+' : ''}${rounded.toLocaleString('fr-FR')}`;
};

// Signed percentage-points string for coverage Δ ("+4 pts" / "-2 pts").
export const signedPts = (currentRate, previousRate) => {
  const c = Number(currentRate);
  const p = Number(previousRate);
  if (!Number.isFinite(c) || !Number.isFinite(p)) return null;
  const pts = Math.round((c - p) * 100);
  return `${pts > 0 ? '+' : ''}${pts} pts`;
};
